import {inject, Injectable} from '@angular/core';
import {environment} from '@environments/environment.prod';
import {map, Observable} from 'rxjs';
import {
  MyHistoryCreditUseCasePort
} from '@features/credit/application/use_cases/my-history-credit/my-history-credit.use-case.port';
import {
  MyHistoryCreditPayloadDto
} from '@features/credit/application/use_cases/my-history-credit/dto/my-history-credit.payload.dto';
import {
  MyHistoryCreditResponseDto
} from '@features/credit/application/use_cases/my-history-credit/dto/my-history-credit.response.dto';
import {ClientHttpPort} from '@shared/application/ports/http/client.http.port';
import {LocalStoragePort} from '@shared/application/ports/storage/local.storage.port';
import {NavigationPort} from '@shared/application/ports/navigation/navigation.port';
import {
  MyHistoryCreditHttpResponseDto
} from '@features/credit/infrastructure/http/my-history-credit/my-history-credit.http.response.dto';
import {
  MyHistoryCreditHttpMapper
} from '@features/credit/infrastructure/http/my-history-credit/my-history-credit.http.mapper';
import {UserEntity} from '@features/user/domain/entities/user.entity';
import {FilterInterface} from '@core/interfaces/filter/filter.interface';
import {HttpHeaders} from '@angular/common/http';

@Injectable({providedIn: "root"})
export class MyHistoryCreditHttpAdapter implements MyHistoryCreditUseCasePort {

  private readonly url = environment.uri;
  private readonly http = inject(ClientHttpPort);
  private readonly localStoragePort = inject(LocalStoragePort);
  private readonly navigationPort = inject(NavigationPort);

  public execute(payload: MyHistoryCreditPayloadDto): Observable<MyHistoryCreditResponseDto> {
    const accountData = this.localStoragePort.getByKey<UserEntity>("_user_data");
    if (!accountData) throw new Error("Could not get user data");
    const filter: FilterInterface = {
      singleQuery: ["user_phone_number", "=", accountData.phone_number],
      withRelationships: [
        // "discounts",
        // "insurance",
        // "untaxed_cost",
        // "taxes_cost",
        // "otherCosts",
      ]
    }
    const headers = new HttpHeaders({
      "x-filter-model": JSON.stringify(filter),
    })
    return this.http.get<MyHistoryCreditHttpResponseDto>(`${this.url}credit-list`, {
      headers
    })
      .pipe(
        map(MyHistoryCreditHttpMapper.toResponse)
      )
  }

}
